"use client";
import {useState} from "react";
import styles from "@/app/styles/components/pages/blog/filter-posts.module.scss";

const BlogPostFilter = ({categories, onChange}) => {
    const [selected, setSelected] = useState();

    const handleSelect = (category) => {
        if (isSelected(category)) {
            setSelected(undefined)
            onChange(undefined)
            return
        }

        setSelected(category)
        onChange(category)
    }

    const isSelected = (category) => {
        return category?.id === selected?.id
    }

    const renderCategories = (categories) => {
        if (!categories) {
            return ''
        }

        let result = [];

        for (let category of categories) {
            result.push(
                <div
                    className={`${styles.categoryFilter} ${isSelected(category) ? styles.categoryFilterSelected : ''}`}
                    onClick={() => handleSelect(category)}
                    key={"post-category-" + category.id}
                >
                    <h3>{category.name}</h3>
                </div>
            );
        }
        return result
    };

    return (
        <>
            <div className={styles.categoryFilterContainer}>
                {renderCategories(categories)}
            </div>
        </>
    );
};

export default BlogPostFilter;
